<script setup>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/useAuthStore'

import LoadingScreen from '@/components/fragments/LoadingScreen.vue'
import NavBar from '@/components/fragments/Navbar.vue'
import Sidebar from '@/components/fragments/Sidebar.vue'

const authStore = useAuthStore()
const { isLoadingPage } = storeToRefs(authStore)
</script>

<template>
  <LoadingScreen v-if="isLoadingPage" />
  <v-app>
    <NavBar />
    <Sidebar />

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<style>
#pageContent {
  margin-left: 0px;
  width: 100%;
  padding-top: 58px;
}

#collapsedContent {
  margin-left: 250px;
  padding-top: 58px;
}

@media screen and (max-width: 520px) {
  #collapsedContent {
    margin-left: 0;
    pointer-events: none;
    padding-top: 48px;
  }

  #pageContent {
    padding-top: 48px;
  }
}
</style>
